import React from "react";
import { Link } from "react-router-dom";
import FadeInSection from "../FadeInSection";
import "./Mythology.css";

const myths = [
  {
    character: "widowmaker",
    myth: "arachne",
    source: "Ovid, Metamorphoses, Book 6",
    summary:
      "Arachne was a mortal weaver from Lydia who boasted she surpassed Athena herself in skill. Athena challenged her to a contest. Arachne's tapestry depicted the gods' infidelities in an unflattering light. Enraged, Athena destroyed the weaving and struck Arachne with her shuttle. Arachne hanged herself in shame. Athena took pity and transformed her into a spider, condemned to weave forever.",
    analysis:
      "Widowmaker's design is built entirely on spider imagery: her grapple hook, her kill-sprays, her skins, and her voice lines all invoke the arachnid. Like Arachne, Widowmaker is a woman stripped of her humanity and reduced to a single, mechanical function. Talon conditioned Amélie Lacroix into a perfect killing machine, erasing her warmth the same way Athena erased Arachne's pride. Ovid captures the aftermath of the transformation: reduced to a spider, Arachne \"still spins a thread, and, as a spider, weaves her ancient web\" (Metamorphoses 6.144–145, trans. Kline). Both figures are punished for exceeding their expected place, and both are condemned to compulsive, endless work.",
  },
  {
    character: "echo",
    myth: "echo",
    source: "Ovid, Metamorphoses, Book 3",
    summary:
      "Echo was a mountain nymph who distracted Hera with endless chatter while Zeus pursued other women. When Hera discovered the trick, she cursed Echo: she could no longer speak first and could only repeat the last words she heard. Echo fell in love with Narcissus, who rejected her. She faded away until only her voice remained, bouncing off mountains and valleys.",
    analysis:
      "Echo in Overwatch is an adaptive AI built to learn and replicate. Her ultimate ability, Duplicate, lets her copy any enemy hero entirely for a short time. Her entire kit is built on reflection. She has no fixed role of her own because her role is to mirror others. This maps directly onto the mythological Echo's curse. Ovid writes that after Hera's punishment, Echo has no power of speech except that \"she can repeat the last words out of many\" (Metamorphoses 3.359–361, trans. Kline). The mythological Echo loses her voice as punishment; the Overwatch Echo was built without one of her own.",
  },
];

export default function MythologyMyths() {
  return (
    <FadeInSection>
      <div className="myth-myths-page">
        <section className="hero-section" id="myth-myths-header">
          <div className="container">
            <Link to="/mythology" className="back-link">← mythology respawned</Link>
            <h1 className="hero-name myth-page-title">myths</h1>
            <p className="hero-role">ancient sources → overwatch characters</p>
          </div>
        </section>

        <section className="myth-myths-section">
          <div className="container">
            {myths.map((m) => (
              <div className="myth-entry" key={m.character}>
                <div className="myth-entry-header">
                  <span className="myth-character">{m.myth}</span>
                  <span className="myth-arrow">→</span>
                  <span className="myth-name">{m.character}</span>
                </div>
                <p className="myth-source">{m.source}</p>
                <p className="myth-summary">{m.summary}</p>
                <p className="myth-analysis">{m.analysis}</p>
              </div>
            ))}
          </div>
        </section>
      </div>
    </FadeInSection>
  );
}
